import { APIS } from '@/constants';
import axios from 'axios';

const commercio = {
  /**
   * Fetch government address for CW20 contract admin
   * @returns {AxiosPromise}
   */
  requestGovernmentAddress() {
    return axios({
      url: '/governmentAddress',
      method: 'get',
      baseURL: APIS.HTTP.GOVERNMENT,
    });
  },
};

export default commercio;
